import React, { useEffect, useRef, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
} from "./ModalComponent";
import { IoMdClose } from "react-icons/io";
import Button from "../Button/Button";
import SearchBar from "../Form/SearchBar";
import { imageUrl } from "../../../config/url";
import { useDispatch, useSelector } from "react-redux";
import { getDriverData } from "../../../redux/actions/driver.action";

import { assignOrdertoDriver } from "../../../redux/actions/user.action";
import { getAssignmentOrder } from "../../../redux/actions/assignment.action";
import { useParams } from "react-router-dom";
import { getDriver } from "../../../redux/actions/auth.action";
import { debounce } from "lodash";
import { toast } from "react-toastify";

const profiles = [
  {
    id: 1,
    image: `${imageUrl}images/ProfileChat.png`,
    name: "Tanner Stafford",
    phone: "+1 123 456 7890",
  },
  {
    id: 2,
    image: `${imageUrl}images/ProfileChat.png`,
    name: "Alex Johnson",
    phone: "+1 987 654 3210",
  },
  {
    id: 3,
    image: `${imageUrl}images/ProfileChat.png`,
    name: "Jamie Smith",
    phone: "+1 555 666 7777",
  },
  {
    id: 4,
    image: `${imageUrl}images/ProfileChat.png`,
    name: "Patricia Brown",
    phone: "+1 444 333 2222",
  },
  {
    id: 5,
    image: `${imageUrl}images/ProfileChat.png`,
    name: "Michael Williams",
    phone: "+1 111 222 3333",
  },
];

const AssignModal = ({ openModal, closeModal }) => {

  const driverListRef = useRef(null);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");
  const [selectedDriverId, setSelectedDriverId] = useState(null);
  const handleCheckboxChange = (driverId) => {
    setSelectedDriverId(driverId);
  };

  const { id } = useParams();
  const { loading, drivers, total } = useSelector((state) => state.driver);
  const dispatch = useDispatch();

  useEffect(() => {
    openModal?.open == true &&
      dispatch(
        getDriver({
          user_id: localStorage.getItem("user_id"),
          search: search,
          page: 1,
          limit: limit,
        })
      );
  }, [openModal, limit, search]);

  const handleAssignDriver = () => {
    if (selectedDriverId) {
      dispatch(
        assignOrdertoDriver({
          user_id: localStorage.getItem("user_id"),
          order_id: openModal.data?._id,
          driver_id: selectedDriverId,
        })
      ).unwrap().then(() => {
        closeModal();
        // dispatch(getAssignmentOrder({ assignment_id: id, page: 1, limit: 10, search: "", user_id: localStorage.getItem("user_id") }))
      });
    } else {
      toast.error("Please select driver")
    }


  };

  const handleSearch = debounce((value) => {
    setSearch(value);
  }, 500);

  const handleScroll = () => {

    if (driverListRef.current && !loading) {
      const { scrollTop, scrollHeight, clientHeight } = driverListRef.current;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        // Load more data if there are more records
        if (drivers?.length < total) {
          setLimit((prevLimit) => prevLimit + 10); // Increase limit by 10
        }
      }
    }
  };

  return (
    <>
      <Dialog open={openModal?.open} onOpenChange={closeModal}>
        <DialogContent>
          <DialogHeader>
            <div className="flex justify-between items-center w-full border-b border-[#F1F5F9] px-4 py-4">
              <h1 className="text-[#0F172A] text-lg font-bold">
                Assign to Driver
              </h1>
              <div
                className="bg-[#F8FAFC] w-10 h-10 rounded-lg flex justify-center items-center"
                onClick={closeModal}
              >
                <IoMdClose className="text-[#64748B]" />
              </div>
            </div>
          </DialogHeader>
          <DialogDescription >
            <div className="px-4">
              <SearchBar type="text" placeholder="Search..." onChange={(e) => handleSearch(e.target.value)} />
            </div>
            <div className="px-4 pt-2 pb-4 max-h-[400px] overflow-y-auto noScrollbar " ref={driverListRef}
              onScroll={handleScroll}>
              {drivers.map((profile, index) => (
                <label
                  key={index}
                  className="flex items-center justify-between space-x-3 py-4 cursor-pointer"
                >
                  <div className="flex gap-3 items-center">
                    <img
                      src={profile.profile}
                      alt="Profile"
                      className="w-[48px] h-[48px] rounded-full"
                    />
                    <div className="space-y-1">
                      <h1 className="text-sm font-bold text-[#0F172A] capitalize">
                        {profile.name}
                      </h1>
                      <p className="text-xs font-normal text-[#64748B]">
                        +{profile.ccode} {profile.phone}
                      </p>
                    </div>
                  </div>
                  <input
                    type="checkbox"
                    className="border-gray-300 rounded h-5 w-5"
                    checked={selectedDriverId === profile._id}
                    onChange={() => handleCheckboxChange(profile._id)}
                  />
                </label>
              ))}

            </div>
            <div className="py-5 border-t border-[#F1F5F9] px-4">
              <Button
                text="Assign to Driver"
                type={true}
                className="w-full py-3 rounded-lg"
                onClick={() => {
                  handleAssignDriver();
                }}
              />
            </div>
          </DialogDescription>
          {/* <DialogFooter>footeerrr</DialogFooter> */}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AssignModal;
